import { getFirstAndLastNameFromDisplayName, useFirebase } from '@scouts/auth'

import { useUserMetadataFromHash } from './use-user-metadata-from-hash'

export const useAuthenticationProfileData = () => {
    const { user } = useFirebase()
    const { userMetadata } = useUserMetadataFromHash()

    const { email, uid: googleIdentityExternalId, displayName } = user || {}

    const { firstName, lastName } = getFirstAndLastNameFromDisplayName(displayName ?? '')

    const profileData = {
        email: email ?? undefined,
        emailMarketingConsent: userMetadata?.hasAgreedToMarketingEmails,
        externalId: userMetadata?.externalId,
        firstName: userMetadata?.firstName || firstName || email,
        googleIdentityExternalId,
        lastName: userMetadata?.lastName || lastName,
    }

    return { profileData }
}
